import type { RouteLocationNormalized, Router } from "vue-router"

/* This guard handles navigation to portal routes, 
ensuring that 'rgn' query parameter is preserved when navigating when navigating between portal routes. 
'rgn' parameter marks that portal is opened via clicking on a link in the backoffice. */

export function registerPortalGuard(router: Router,) {
  router.beforeEach(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    if (to.meta.isPortal && from.query.rgn && (!to.query.rgn || to.query.rgn !== from.query.rgn)) {
    // Apply the 'rgn' parameter to the destination portal route
    return {
        ...to,
        query: {
        ...to.query,
        rgn: from.query.rgn
        }
    }
}

    return true
  })
}